import { css } from '@emotion/css';
import { computed } from 'vue';

export const useStyles = () => {
  const baseClass = computed(() => css({
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    zIndex: 29,
    display: 'none',
    background: 'hsla(0,0%,100%,.5)',
    '&--active': {
      display: 'flex',
    },
    '&--full-page': {
      position: 'fixed',
      zIndex: 999,
    },
  }));

  return baseClass;
};
